@if (isEmpty()) {
  <p class="empty">No summary available.</p>
} @else {
  @if (keywords().length) {
    <div class="block">
      <div class="block-label">Keywords</div>
      <div class="chips">
        @for (kw of keywords(); track kw) {
          <span class="chip">{{ kw }}</span>
        }
      </div>
    </div>
  }

  @if (sections().length) {
    <div class="block">
      <div class="block-label">Details</div>
      <ul class="detail-list">
        @for (section of sections(); track section.label) {
          <li [class.context]="section.isContext">
            @if (section.label) {
              <strong>{{ section.label }}: </strong>
            }
            <span>{{ section.value }}</span>
          </li>
        }
      </ul>
    </div>
  }

  @if (suggestedProviders().length) {
    <div class="block">
      <div class="block-label">Suggested providers ({{ suggestedProviders().length }})</div>
      <ul class="provider-list">
        @for (p of suggestedProviders(); track p.id) {
          <li class="provider-item">
            <span class="provider-name">{{ p.name }}</span>
            <span
              class="provider-jobs"
              [class.zero]="!p.completed_orders_count"
              title="Completed orders">
              <span class="provider-jobs-check" aria-hidden="true">✓</span>{{ p.completed_orders_count }}
            </span>
            @if (p.is_previous_for_client) {
              <span class="provider-previous">Worked with this client</span>
            }
            @if (p.is_recommended) {
              <span class="provider-recommended">Recommended</span>
            }
          </li>
        }
      </ul>
    </div>
  }

  @if (unavailablePreviousProvider(); as previous) {
    <div class="block">
      <div class="block-label">Requested provider</div>
      <p class="provider-unavailable">
        Client asked for <strong>{{ previous.name }}</strong>, who is not available for this
        case. Suggestions above follow the usual rotation.
      </p>
    </div>
  }
}